import "../styles/ScoreCard.css";
import gold from "../assets/images/gold medal.png"
import silver from "../assets/images/silver medal.png"
import bronze from "../assets/images/bronze medal.png"

const ScoreCard = ({  title,p1,p2,p3, onDetails }) => {
  return (
    <div className="score-card">
      

      <h3>{title}</h3>

      <div>
        
        <div id="p1">
            <p>{p1}</p>
            <img src={gold} alt="Gold medal" />
        </div>

        <div id="p2">
            <p>{p2}</p>
            <img src={silver} alt="Silver medal" />
        </div>

        <div id="p3">
            <p>{p3}</p>
            <img src={bronze} alt="Bronze medal" />
        </div>

        <button className="details-btn" onClick={onDetails}>
          View All
        </button>

      </div>
    </div>
  );
};

export default ScoreCard;
